import React, { memo, useMemo } from 'react';
import classNames from 'classnames/bind';
import { Text } from "../../../Text";
import { getTextColor } from "../../utils/getTextColor";
import style from "./styles.pcss";
var cn = classNames.bind(style);
export var StepNumber = /*#__PURE__*/memo(function (_ref) {
  var isClickable = _ref.isClickable,
    selected = _ref.selected,
    stepNumber = _ref.stepNumber,
    _ref$transitionTime = _ref.transitionTime,
    transitionTime = _ref$transitionTime === void 0 ? 0 : _ref$transitionTime;
  var numberColor = useMemo(function () {
    return getTextColor({
      isClickable: isClickable,
      selected: selected,
      transitionTime: transitionTime,
      type: 'number'
    });
  }, [isClickable, selected, transitionTime]);
  return /*#__PURE__*/React.createElement("div", {
    className: cn('number', {
      'number--selected': selected && isClickable && !transitionTime
    }),
    "data-t-id": "components-StepNumber"
  }, selected && transitionTime > 0 && /*#__PURE__*/React.createElement("svg", {
    className: cn('circle'),
    height: "36",
    width: "36"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "18",
    fill: "transparent",
    r: "16",
    stroke: "black",
    strokeDasharray: "100",
    strokeLinecap: "round",
    strokeWidth: "3"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    dur: "".concat(transitionTime, "s"),
    values: "100;0"
  })), /*#__PURE__*/React.createElement(Text, {
    color: numberColor,
    size: "size4-r",
    tagType: "span"
  }, stepNumber));
});